import axios from 'axios';
import { stringify } from "qs";
import { showFormAlert } from '../general/form-ajax-alert';
import { favouritesEditModal } from '../favourites/favourites-edit-modal';
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import { checkSelectedInputs } from '../reviews/review-filter-sort-utilities';
import { resetValidationInputCheck } from './form-validation';
import { bind_swiper } from '../integration/swiper';

const { site, is_mobile_device, search_autocomplete_query, search_autocomplete_permalink, search_allocation_child_ages
 } = window.tg;
const bsn = require('bootstrap.native');
let bsnModal = new bsn.default.Modal('#js-modal');
const modalBody = document.querySelector('.modal-body');

const url = new URL(document.URL);
let redirectUrl = url.searchParams.has("redirect_url") ? url.searchParams.get("redirect_url") : url.href;
/**
 * Opens specified modal
 * @param {string} target
 * @param {object} data
*/

function openModal(target, data = {}, modalMaxWidth = 710) {
    // Close any open trays
    window.Alpine?.store?.('general')?.updateOpenTray?.("NONE");

    //Remove all alerts
    var alerts = document.querySelectorAll(".modal-content .alert");
    alerts.forEach(alert => {
        alert.classList.add("d-none");
    });

    // Close any open trays
    if (site == 'vy' && !['NONE', 'reviews'].includes(Alpine.store('general').tray.openTray) && !(target == 'otp' && data.isLoginTray == 1)) {
        Alpine.store('general').updateOpenTray('NONE')
    }

    // Open signup modal on first step if user clicks on signup link from login modal
    if (target == 'signup' && site == 'vy' && data.clickSource == 'login-modal') {
        Alpine.store('auth').signupStep = 1
    }

    // Login tray for viya
    if (site == 'vy' && target == 'login' && data.tray == true) {
        Alpine.store('general').updateOpenTray('login', 'Log in to ' + data.action, 0, true, 50, false, false, data)
        return
    }

    if (site === 'ls' && ['signup', 'login'].includes(target)) {
        const desktopMenuEl = document.getElementById("menu-desktop");
        const languageOverlay = document.getElementById('js-language-overlay');
        languageOverlay?.classList.add('d-none');
        desktopMenuEl?.classList.remove("push-right-front");
    }

    if (target === 'otp' && data.resend == "true") {
        let formEl = document.querySelector("#js-modal-otp-form");

        const btn_loader = '<div class="btn-loader"><div class="rect1"></div> <div class="rect2"></div> <div class="rect3"></div> <div class="rect4"></div> <div class="rect5"></div></div>';

        const submitEl = /** @type {HTMLButtonElement} */ (formEl.querySelectorAll('button[type="submit"]')[0]);
        const submitElInnerHTML = submitEl.innerHTML;
        submitEl.style.width = (Math.ceil(submitEl.offsetWidth) + 1) + 'px'; // 2 for borders
        submitEl.disabled = true;
        submitEl.innerHTML = btn_loader;

        axios({
            url: '/auth/request-otp',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                email: data.email,
                source: data.source,
                resend: true
            }),
        }).then((response) => {
            const output = response.data;
            let status = '';
            let reason = '';
            if (output.success) {
                status = 'SUCCESS';
            } else {
                status = 'WARNING';
            }
            if (output.data && output.data.reason) {
                reason = output.data.reason;
            } else {
                status = 'WARNING';
            }

            setTimeout(function () {
                submitEl.innerHTML = submitElInnerHTML;
                submitEl.disabled = false;
                showFormAlert(formEl.id, status, reason);

                if (!(target == 'otp' && data.isLoginTray == 1)) {
                    // For modals, add some margin on top of the form error
                    document.querySelector('.modal-content .alert').classList.add('mt-3');
                }
            }, 500)

        });
    } else {
        if (target === 'ops-confirm-stay') {
            data.search_autocomplete_query = search_autocomplete_query;
            data.search_autocomplete_permalink = search_autocomplete_permalink;
            data.child_ages = search_allocation_child_ages

            // Get filter data
            let form = document.getElementById("form-sidebar-filters");
            let filterData = serializeForm(form);
            let inputMin = document.getElementById("js-filter-price-input-min");
            let inputMax = document.getElementById("js-filter-price-input-max");
            let prices = {};

            data.filter_data = filterData;
            prices.min = inputMin.value ? inputMin.value : inputMax.getAttribute('data-default');
            prices.max = inputMax.value ? inputMax.value : inputMin.getAttribute('data-default');
            data.prices = prices;
        }

        if (target !== undefined) {
            axios({
                url: '/backend/cms/modal',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: stringify({
                    target: target,
                    data: data
                }),
            }).then((response) => {
                const output = response.data;

                if (output.success) {
                    const data = output.data;

                    // Modal areas
                    let dialog = /** @type {HTMLElement} */ (document.querySelector('.modal-dialog'));

                    const outerModal = document.getElementById('js-modal');

                    if (outerModal) {
                        outerModal.addEventListener('click', () => {
                            clearAllBodyScrollLocks();
                        })
                    }

                    if (site != 'vy') {
                        dialog.style.maxWidth = `${modalMaxWidth}px`;
                    }

                    if (target === 'language') {
                        // Keep backgroup unclickable to close for language
                        bsnModal = new bsn.default.Modal('#js-modal', { backdrop: 'static', keyboard: false });
                    } else {
                        bsnModal = new bsn.default.Modal('#js-modal');
                    }

                    bsnModal.show();
                    bsnModal.setContent(data['html'])
                    bsnModal.update();

                    if (data['scroll_to']) {
                        const scrollToEl = document.getElementById(data['scroll_to']);

                        if (scrollToEl) {
                            setTimeout(() => {
                                scrollToEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 200); // Hacky but we need to wait for the modal to be open first :(
                        }
                    }

                    // review filter modal options handler
                    if (site == 'ls' && target == 'filter') {

                        const inputs = document.querySelectorAll('.modal-content input[type="checkbox"]');
                        checkSelectedInputs(inputs);
                    }

                    // sort modal option handler
                    if (site == 'ls' && target == 'sort') {
                        const sort_options = document.querySelectorAll('input[name="sort_option"]');
                        const currentSortType = Alpine.store('review').sort_type;

                        // If currentSortType is not set, default to Recommended, Otherwise set the current sort type
                        sort_options.forEach(sort_option => {
                            if ((sort_option.getAttribute('value') === currentSortType) || (!currentSortType && sort_option.id === "Recommended")) {
                                sort_option.checked = true;
                            }
                        });
                    }

                    if (target == 'wishlist') {
                        setTimeout(() => {
                            var wishlistBodyEl = /** @type {HTMLDivElement} */ (document.querySelector('.js-wishlist-body'));

                            if (wishlistBodyEl) {
                                if (wishlistBodyEl.offsetHeight < wishlistBodyEl.scrollHeight) {
                                    const scrollMsgEl = document.querySelector('.js-wishlist-scroll-more');
                                    scrollMsgEl.classList.remove("d-md-none");
                                    scrollMsgEl.classList.add("d-md-block");
                                }
                            }
                        }, 300);
                    }

                    if (target == 'favourites-edit') {
                        dialog.style.maxWidth = '560px';
                        favouritesEditModal();
                    }

                    if (target == 'tokenisation-information') {
                        const modalContainer = document.getElementById("tokenisation-information-container");
                        if (is_mobile_device) {
                            modalContainer.style.height = '100%';
                        }
                    }

                    if (target == "ops-confirm-stay") {
                        dialog.style.maxWidth = '700px';
                    }


                    if (target === 'signup' && site === 'ls') {
                        const closeModalButtonMobile = document.getElementById("close-modal-button-ls")
                        const closeModalButton = document.querySelector(".close-modal")

                        window.bind_swiper('.onboarding-swiper-ls');

                        if (is_mobile_device) {
                            // lock body scroll when onboarding modal is open
                            if (modalBody) {
                                disableBodyScroll(modalBody);
                            }

                            // clear body scroll locks when modal is closed
                            if (closeModalButtonMobile) {
                                closeModalButtonMobile.addEventListener('click', (event) => {
                                    clearAllBodyScrollLocks();
                                })
                            }
                        }


                        // Referesh page when user clicks on close modal button if on signup success modal on desktop
                        if (closeModalButton) {
                            closeModalButton.addEventListener('click', () => {
                                if (Alpine.store('auth').signupStep === 1) {
                                    window.location.href = redirectUrl;
                                }
                            })
                        }

                        // Refresh page when user clicks outside of signup modal if on signup-success modal
                        let modalEl = document.querySelector('#js-modal')
                        modalEl.addEventListener('click', (event) => {
                            if (!event.target.classList.contains('fade')) {
                                clearAllBodyScrollLocks();
                                return
                            }

                            if (Alpine.store('auth').signupStep === 1) {
                                window.location.href = redirectUrl;
                            }
                        })
                    }

                    if (target == 'signup' && site == 'vy') {
                        window.bind_swiper('.js-swiper-signup');

                        // Refresh page when user clicks outside modal after step 1 of signup
                        let modalEl = document.querySelector('#js-modal')
                        modalEl.addEventListener('click', (event) => {
                            if (!event.target.classList.contains('fade')) {
                                return
                            }

                            if (Alpine.store('auth').signupStep > 1) {
                                const url = new URL(document.URL);
                                let redirectUrl = url.searchParams.has("redirect_url") ? url.searchParams.get("redirect_url") : url.href;
                                if (Alpine.store('auth').signupRewardPoints.pointsEarned > 0) {
                                    redirectUrl += (redirectUrl.includes("?") ? "&" : "?") + ("points_earned=" + Alpine.store('auth').signupRewardPoints.pointsEarned + "&points_reason=" + encodeURI(Alpine.store('auth').signupRewardPoints.pointsReason) + "&icon=" + encodeURI(Alpine.store('auth').signupRewardPoints.pointsIcon));
                                }
                                window.location.href = redirectUrl;
                            }
                        })
                    }
                    if ( ['login', 'signup'].includes(target) && site == 'ls' ) {
                        resetValidationInputCheck();
                    }
                    if (target === 'host-overview'){
                        window.bind_swiper('.js-swiper-peek');
                    }
                    if (site === 'ls' && target === 'single-review' ) {

                        window.bind_swiper('.js-swiper-peek', 'single-review');

                        function reviewTranslation() {
                            if(document.querySelector("#translation-button")) {
                                document.querySelector("#translation-button").addEventListener('click', function () {
                                    const reviewId = this.getAttribute("data");
                                    const englishReview = document.getElementById(`translated-review-${reviewId}`);
                                    const originalReview = document.getElementById(`original-review-${reviewId}`);
                                    const translationText = document.getElementById(`review-translation-${reviewId}`);

                                    if (englishReview && originalReview) {
                                        if (englishReview.classList.contains("d-none")) {
                                            englishReview.classList.remove("d-none");
                                            originalReview.classList.add("d-none");
                                            this.innerHTML = '<u>Show original</u>';
                                            translationText.textContent = 'This review has been automatically translated using Google.';
                                        } else {
                                            englishReview.classList.add("d-none");
                                            originalReview.classList.remove("d-none");
                                            this.innerHTML = '<u>Translate to English</u>';
                                            translationText.textContent = 'This review is displayed in the original language.';
                                        }
                                    }
                                });
                            }
                        }
                        function responseTranslation() {
                            if(document.querySelector("#host-response-translation-button")) {
                                document.querySelector("#host-response-translation-button").addEventListener('click', function () {
                                    const reviewId = this.getAttribute("data");
                                    const englishResponse= document.getElementById(`translated-host-response-${reviewId}`);
                                    const originalResponse = document.getElementById(`original-host-response-${reviewId}`);
                                    const translationText = document.getElementById(`host-response-translation-${reviewId}`);

                                    if (englishResponse && originalResponse) {
                                        if (englishResponse.classList.contains("d-none")) {
                                            englishResponse.classList.remove("d-none");
                                            originalResponse.classList.add("d-none");
                                            this.innerHTML = '<u>Show original</u>';
                                            translationText.textContent = 'This review has been automatically translated using Google.';
                                        } else {
                                            englishResponse.classList.add("d-none");
                                            originalResponse.classList.remove("d-none");
                                            this.innerHTML = '<u>Translate to English</u>';
                                            translationText.textContent = 'This review is displayed in the original language.';
                                        }
                                    }
                                });
                            }
                        }
                        responseTranslation();
                        reviewTranslation();
                    }
                }
            });
        }
    }
}

function serializeForm(form) {
  const out = {};
  if (!form || form.nodeName !== "FORM") return out;

  const fields = Array.from(form.elements).filter(el => el.name && !el.disabled);
  const acc = new Map();

const push = (name, value, label) => {
  if (!acc.has(name)) acc.set(name, []);
  acc.get(name).push({ value, name: (label || "").trim() });
};


  const getLabel = (el) => {
    const byFor = el.id && form.querySelector(`label[for="${(window.CSS && CSS.escape) ? CSS.escape(el.id) : el.id}"]`);
    const labelEl = byFor || el.closest('label');
    if (labelEl) return labelEl.textContent.replace(/\s+/g, ' ').trim();
    if (el.getAttribute('aria-label')) return el.getAttribute('aria-label');
    if (el.placeholder) return el.placeholder;
    return el.name;
  };

  for (const el of fields) {
    const tag = el.tagName.toLowerCase();
    const type = (el.type || '').toLowerCase();

    if ((type === 'checkbox' || type === 'radio') && !el.checked) continue;

    if (tag === 'select') {
      Array.from(el.selectedOptions).forEach(opt => {
        push(el.name, opt.value, opt.text);
      });
      continue;
    }

    if (type === 'file') continue;

    if (type === 'checkbox' || type === 'radio') {
      if (el.checked) push(el.name, el.value, getLabel(el));
    } else {
      push(el.name, el.value, getLabel(el));
    }
  }

  for (const [name, items] of acc.entries()) {
  out[name] = items; // always an array, no overwrite
}

  return out;
}

export { openModal };
